import { render, staticRenderFns } from "./PagePeopleAutocomplete.vue?vue&type=template&id=2f99490a"
import script from "./PagePeopleAutocomplete.vue?vue&type=script&lang=js"
export * from "./PagePeopleAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports